import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Usa scroll suave si el usuario ya está arriba para evitar saltos innecesarios
    const behavior = window.scrollY < 20 ? "auto" : "smooth";
    window.scrollTo({ top: 0, left: 0, behavior });
  }, [pathname]);

  return null;
}

